import { QueryClient, useMutation, useQuery } from '@tanstack/react-query'
import React, { useEffect, useState } from 'react'
import Loading from '../Loading'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import { getData } from '../myComponents/QuranApi';

const QuranView = () => {
  const queryClient = new QueryClient();
  const [mushafView, setMushafView] = useState(false);
  const navigate = useNavigate();
  let verse = "2_100";

  const handleToggleView = () => {
    setMushafView(!mushafView);
  }

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ["view"] });
    queryClient.invalidateQueries({ queryKey: ["textview"] });
  }, [verse])



  return (<>
    <div>
      <FloatingMenuLeft handleToggleView={handleToggleView} />
      <div className=''>{mushafView ? <MushafView d={verse} /> : <TextView d={verse} />}</div>
    </div>
  </>

  )
}

export default QuranView;



const TextView = (props) => {
  const verse = props.d;
  const [currentQuestion, setCurrentQuestion] = useState(1)
  const [datas, setDatas] = useState([])

  const { mutate, isLoading, isFetching, reset } = useMutation({
    mutationKey: ['textview'],
    mutationFn: async (verse) => {
      //const { data: vdata } = await axios.get(`https://api.quran.com/api/v4/verses/by_key/${versekey}`)
      // const vdata = getData("vid", verse)[0]
      const vid = currentQuestion === 1 ? localStorage.getItem("q1") : localStorage.getItem("q2");
      const verseId = parseInt(vid)
      const vdata = getData("vid", verseId)[0]
      console.log("vdata", vdata)
      const page = vdata?.page;
      // const verseId = vdata?.oid;
      const page1 = getData("page", page)
      const page2 = getData("page", parseInt(page) + 1)
      const pages = [...page1, ...page2];
      const filtered = pages.filter(p => p.vid >= verseId)
      console.log(filtered)
      setDatas(filtered);
      return filtered
    }
  })

  useEffect(() => {
    reset()
    mutate(verse)
  }, [])

  useEffect(() => {
    reset()
    mutate(verse)
  }, [verse])

  if (isLoading || isFetching) return <div className='p-10'><Loading /></div>

  return (<>
    {/* <div className='p-5'>{JSON.stringify(datas[0])}</div> */}

    {/* {JSON.stringify(data[0])} */}

    <div className='floatingcenter absolute left-60  ml-0 mr-0 w-1/4'>
      <div className='flex justify-left gap-2 text-xs'>
        <div className='flex justify-center'> <Button label="NEXT" styles="bg-green-800" /></div>
        <div className='flex justify-center'> <Link to={"/questions"} className={`bg-green-800 buttonnav cursor-pointer text-white rounded-full px-2`}>QTNS</Link></div>
      </div>
    </div>

    <div className='floatingright absolute right-0 ml-0 mr-0 w-1/4'>
      <div className='flex justify-center gap-2 text-xs'>
        <div className='flex justify-center'> <Button label="NEXT" styles="bg-green-800" /></div>
        {/* <div className='justify-right'> <Button label="DONE" styles="bg-blue-800"/></div> */}
      </div>
    </div>


    <div className='arabic flex justify-around pagehead -mb-5'>
      <div><span> سورة </span> <span>: {datas[0]?.sura_name_ar} </span></div>
      <div><span> الصفحة </span> <span>: {datas[0]?.page} </span> <span> الآية </span> <span>: {datas[0]?.aya_number} </span></div>
    </div>
    <div className="viewcontainer ring-2 ring-black">
      <div className='px-1 pt-3  ring-2 ring-black rounded-lg'>
        {datas?.map((p, i) => (
          <span
            key={i}
            className="ayah"
          >
            {p?.verse_text_vn}{datas?.length === 0 && <Loading />}
          </span>
        ))}
      </div>
      {/* <span className='text-2xl'>ٱلَّذِینَ یُؤۡمِنُونَ بِٱلۡغَیۡبِ</span> */}
    </div>
    <div className='text-center -m-2 xl:text-2xl'>
      {props?.page}


    </div>
  </>
  );
}


const MushafView = (props) => {
  const verse = props.d;
  console.log('verse', verse)
  const [page, setPage] = useState([])

  const { mutate, isLoading, isFetching, reset } = useMutation({
    mutationKey: ['mushafview'],
    mutationFn: async (verse) => {
      //const { data: vdata } = await axios.get(`https://api.quran.com/api/v4/verses/by_key/${versekey}`)
      const vdata = getData("sv", verse)[0]
      const cpage = vdata?.page
      setPage(cpage)
      return cpage;
    }
  })

  useEffect(() => {
    reset()
    mutate(verse)
  }, [])

  useEffect(() => {
    reset()
    mutate(verse)
  }, [verse])

  if (isLoading || isFetching) return <div className='p-10'><Loading /></div>

  return (<>

    <div dir='rtl' className='flex justify-around pagehead -mb-5'>
      <div><span> الصفحة </span> <span>: {page} </span></div>
      {/* <div><span> الآية </span> <span>: {versedata?.aya_number} </span></div> */}
    </div>
    <div className="viewcontainer ring-2 ring-black flex">
      <div className='p-2 ring-2 ring-black rounded-lg'>
        <img height={10} src={`./quran-images/${parseInt(page)}.png`} alt="" />
        <span className='absolute text-red-900 bg-slate-400 rounded-full -mb-3 xl:text-2xl'>{parseInt(page)}</span>
      </div>
      <div className='p-2 ring-2 ring-black rounded-lg'>
        <img height={10} src={`./quran-images/${parseInt(page) + 1}.png`} alt="" />
        <span className='absolute text-red-900 bg-slate-400 rounded-full -mb-3 xl:text-2xl'>{parseInt(page) + 1}</span>
      </div>
    </div>
    {JSON.stringify(page)}
  </>
  );
}



const Button = (props) => {
  return (
    <button
      onClick={props.onClick}
      className={`buttonnav cursor-pointer text-white rounded-full px-2 ${props.styles}`}
    >
      {props.label}
    </button>
  );
}



const FloatingMenuLeft = (props) => {
  return (
    <div className='absolute'>
      <div className='flex justify-left gap-2 text-xs'>

        <div className='flex justify-center'> <Link to={"/dashboard"} className={`bg-green-800 buttonnav cursor-pointer text-white rounded-full px-2 ${props.styles}`}>HOME</Link></div>
        <div className='flex justify-center'> <Button onClick={props.handleToggleView} label="CHNGE" styles="bg-green-800" /></div>
      </div>
    </div>
  );
}

// const FloatingMenuCenter = (props) => {
//   return (
//     <div className='absolute left-60  ml-0 mr-0 w-1/4'>
//       <div className='flex justify-left gap-2 text-xs'>
//         <div className='flex justify-center'> <Button label="NEXT" styles="bg-green-800" /></div>
//         <div className='flex justify-center'> <Link to={"/questions"} className={`bg-green-800 buttonnav cursor-pointer text-white rounded-full px-2 ${props.styles}`}>QTNS</Link></div>
//       </div>
//     </div>
//   );
// }

// const FloatingNavRight = () => {
//   return <div className='absolute right-0 ml-0 mr-0 w-1/4'>
//     <div className='flex justify-center gap-2 text-xs'>
//       <div className='flex justify-center'> <Button label="NEXT" styles="bg-green-800" /></div>
//       {/* <div className='justify-right'> <Button label="DONE" styles="bg-blue-800"/></div> */}
//     </div>
//   </div>
// }